// extracted by mini-css-extract-plugin
export default {"adDetails":"AdDetails_adDetails__-N+GO","deliveryStatus":"AdDetails_deliveryStatus__zCHth"};